export default "__VITE_ASSET__5569777e__"